/**
 * use-disposal-recommendations — GET /v1/disposal-recommendations (Phase 28 / task 28.5,
 * DEC-331) for the New Job "Destination" picker.
 *
 * Replaces the old GET /v1/disposal-facilities call, which sent no limit and so silently
 * showed only the first 50 facilities alphabetically. This list is every usable place,
 * ranked for the chosen pickup in the company's dispatcher display mode. The customer whose
 * "never send here" list applies is resolved by the server from the pickup. ASSIGN_JOB.
 */

import { useApiQuery, type useApiOpts } from '@lodex-pro/web-shared';
import { recommendationsQuery, type DisposalRecommendationsResponse } from './destination-options';

export function useDisposalRecommendations(
  apiOpts: ReturnType<typeof useApiOpts>,
  pickupSel: string,
): ReturnType<typeof useApiQuery<DisposalRecommendationsResponse>> {
  const qs = recommendationsQuery(pickupSel);
  return useApiQuery<DisposalRecommendationsResponse>(
    apiOpts,
    `/v1/disposal-recommendations${qs}`,
    { queryKey: ['disposal-recommendations', qs], staleTime: 60_000 },
  );
}
